import { DataService } from "@xo/services";

export class System {
  public context: any = {};
  constructor(public name: string, public services: Map<string, DataService<any>> = new Map<string, DataService<any>>()) { }
}
